import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardSurfaceActionsOption')(function discardSurfaceActionsOption(state) {
    var optionState = state.optionState;
    optionState.readSurfaceActions = null;
    optionState.readSurfaceAddins = null;
    optionState.composeSurfaceActions = null;
    optionState.composeSurfaceAddins = null;
}));
//# sourceMappingURL=discardSurfaceActionsOption.js.map